var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
// Components
import { BaseElement } from '@frontend_zz/base-element/BaseElement.js';
// Styling
import styles from './Text.css.js';
// Typings
export const tagOptions = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'];
export const styleAsOptions = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'body', 'body-bold', 'body-small'];
// Typings — legacy, remove when consumers have updated to new unified `as-style` prop
export const colorOptions = ['heading', 'dark', 'light', 'error', 'inherit'];
export const fontOptions = ['normal', 'special', 'number'];
export const lineHeightOptions = ['normal', 'large'];
export const sizeOptions = ['xxxl', 'xxl', 'xl', 'l', 'm', 's', 'xs', 'xxs', 'xxxs', 'xxxxs'];
export const weightOptions = ['normal', 'medium', 'bold'];
/**
 * @element zz-text
 */
export class Text extends BaseElement {
    constructor() {
        super(...arguments);
        this.tag = 'p';
        this.ellipsis = false;
        /**
         * @deprecated
         */
        this.responsive = false;
    }
    static get styles() {
        return [styles];
    }
    render() {
        const template = `
            <${this.tag}><slot></slot></${this.tag}>
        `;
        return html `${unsafeHTML(template)}`;
    }
}
__decorate([
    property({ type: String, reflect: true })
], Text.prototype, "tag", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'style-as' })
], Text.prototype, "styleAs", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], Text.prototype, "ellipsis", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], Text.prototype, "responsive", void 0);
__decorate([
    property({ type: String, reflect: true })
], Text.prototype, "color", void 0);
__decorate([
    property({ type: String, reflect: true })
], Text.prototype, "font", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'line-height' })
], Text.prototype, "lineHeight", void 0);
__decorate([
    property({ type: String, reflect: true })
], Text.prototype, "size", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'weight' })
], Text.prototype, "weight", void 0);
